export default function () {
  controller('prod-slider', self => {
    const $slider = $(self);
    const arrow = '<svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16"><path fill-rule="evenodd" d="M8.724 8.661a.93.93 0 0 0 0-1.322L1.47.137a.473.473 0 0 0-.666 0L.138.798a.465.465 0 0 0 0 .661l6.255 6.21a.465.465 0 0 1 0 .661L.138 14.54a.465.465 0 0 0 0 .662l.666.661a.473.473 0 0 0 .666 0l7.254-7.202z"/></svg>';

    if ($slider.length) {
      $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<span class="slick-prev">' + arrow + '</span>',
        nextArrow: '<span class="slick-next">' + arrow + '</span>'
      })
    }
  });
}
